module.exports = __webpack_public_path__ + "images/emoji/candy.c5df7c388337b5427759.png";